import { Module } from 'vuex-module-decorators'
import NewAbstract from '~/store/new-abstract'

@Module({
  name: 'new-order',
  stateFactory: true,
  namespaced: true,
})
export default class NewPromo extends NewAbstract {}
